import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/HomePage.tsx");
